import { takeLatest, call, put } from 'redux-saga/effects';
import { types, actions } from './duck';
import {
  getFollowedBusinesses,
  followBusiness,
  unfollowBusiness,
} from '../api';

function* getFollowedBusinessesSaga(action) {
  try {
    const response = yield call(getFollowedBusinesses, action.params);
    yield put(actions.getFollowedBusinessesSuccess(response.data));
  } catch (error) {
    yield put(actions.getFollowedBusinessesFailure(error));
  }
}

function* followBusinessSaga(action) {
  try {
    const response = yield call(followBusiness, action.data);
    yield put(actions.followBusinessSuccess(response.data));
  } catch (error) {
    yield put(actions.followBusinessFailure(error));
  }
}

function* unfollowBusinessSaga(action) {
  try {
    const response = yield call(unfollowBusiness, action.data);
    yield put(actions.unfollowBusinessSuccess(response.data));
  } catch (error) {
    yield put(actions.unfollowBusinessFailure(error));
  }
}

export default function* saga() {
  yield takeLatest(
    types.GET_FOLLOWED_BUSINESSES_REQUEST,
    getFollowedBusinessesSaga,
  );
  yield takeLatest(types.FOLLOW_BUSINESS_REQUEST, followBusinessSaga);
  yield takeLatest(types.UNFOLLOW_BUSINESS_REQUEST, unfollowBusinessSaga);
}
